import CustomStore from "devextreme/data/custom_store";
import { apiConfiguration } from "../apiConfig";
import { AssistitiApi, EmergenzeApi } from "../data/apis";
import { useContext, useMemo } from "react";
import TenantContext from "../contexts/tenantContext";

export function useCurrentEmergenzaAssistitiDataSource() {
  const api = new EmergenzeApi(apiConfiguration);
  const { currentTenant } = useContext(TenantContext);

  const dataSource = useMemo(() => {
    return new CustomStore({
      key: "id",
      loadMode: 'raw',
      load: (loadOptions) => api.getCurrentEmergenzaAssistitiByCurrentOperatore({ tenantId: currentTenant.Id })
    });
  }, [currentTenant]);

  return dataSource;
}


